'use client';

import type { Column } from '@tanstack/react-table';
import * as React from 'react';
import { CascadingFilter, CascadingFilterNode } from './cascading-filter';

interface DataTableCascadingFilterProps<TData, TValue> {
  column?: Column<TData, TValue>;
  title?: string;
  nodes: readonly CascadingFilterNode[];
  isLoading?: boolean;
}

/**
 * Column-bound {@link CascadingFilter}: the column's filter value is the
 * applied path, outermost first, and clearing drops the filter altogether.
 */
export function DataTableCascadingFilter<TData, TValue>({
  column,
  title = 'Category',
  nodes,
  isLoading,
}: DataTableCascadingFilterProps<TData, TValue>) {
  const columnFilterValue = column?.getFilterValue();
  const selectedPath = React.useMemo(
    () =>
      Array.isArray(columnFilterValue) ? (columnFilterValue as string[]) : [],
    [columnFilterValue]
  );

  const onSelect = React.useCallback(
    (path: string[]) => column?.setFilterValue(path.length ? path : undefined),
    [column]
  );

  return (
    <CascadingFilter
      title={title}
      nodes={nodes}
      selectedPath={selectedPath}
      isLoading={isLoading}
      rootHeading="Categories"
      clearLabel="All categories"
      emptyMessage="No categorised purchases"
      onSelect={onSelect}
      onClear={() => column?.setFilterValue(undefined)}
    />
  );
}
